<template lang="pug">
v-dialog(v-model="processDeployDialog" max-width="600px"
  :fullscreen="$vuetify.breakpoint.xsOnly")
  v-card(light)
    v-card-title
      h3 {{ $tf("process.deploy.title") }}
    v-divider
    v-card-text
      v-layout(row wrap)
        v-flex(xs12)
          v-text-field(:label="$tf('process.deploy.processName')" v-model="processName" placeholder=" " disabled)
        v-flex(xs12)
          v-btn.ma-0(color="primary" class="white--text" @click.native="$refs.file.click()") {{ $tf("process.deploy.selectFile") }}
            v-icon(right dark) cloud_upload
      input(ref="file" v-if="processDeployDialog" style="display:none" @change="onChange($event)" type="file" accept=".bpmn" )
    v-card-actions.px-3.pb-3
      v-spacer
      v-btn(@click="toggleProcessDeployDialog(false)" color="blue darken-1" flat) {{ $tf("process.deploy.close") }}
      v-btn(@click="processDeploy" color="primary" :disabled="loading") {{ $tf("process.deploy.deploy") }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ProcessDeploy',

  data() {
    return {
      processFile: null,
    }
  },

  computed: {
    ...mapGetters({
      processDeployDialog: 'process/processDeployDialog',
      loading: 'tools/loading',
    }),

    processDeployDialog: {
      get() {
        return this.$store.getters['process/processDeployDialog']
      },
      set(value) {
        this.toggleProcessDeployDialog(value)
      },
    },

    processName() {
      if (this.processFile) {
        return this.processFile[0].name.slice(0, -5)
      }
      return ''
    },
  },

  watch: {
    processDeployDialog() {
      this.processFile = null
    },
  },

  methods: {
    ...mapActions({
      toggleProcessDeployDialog: 'process/toggleProcessDeployDialog',
      deploy: 'process/deploy',
      setSnackbar: 'tools/setSnackbar',
    }),

    onChange(event) {
      this.processFile = event.target.files
      this.processDeploy()
    },

    processDeploy() {
      if (this.processFile) {
        this.deploy({ processName: this.processName, deploymentSource: this.processName, file: this.processFile[0] })
      } else {
        this.setSnackbar(this.$tf('process.deploy.fileRequired'))
      }
    },
  },
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/process/ProcessDeploy.vue